/**
 * Created by Carsten Bühler
 * User: c.buehler on 08.06.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

//Includes
import React from 'external/react';
import {
    AppContext,
    ContextContainer,
    flagHOC,
    FormActions,
    ScrollableDataListRV,
    translation,
    wrapWithCommonFormContainer,
    ConfirmFormContainer
} from 'plugin/liferay-widgets-react-web';
import { Button, Col, Container, Row } from 'external/react-bootstrap';

import { getLayerDataSourceStore, getLogicalLayerStore } from '../stores/StoreFactory';
import LogicLayerListItem from '../components/LogicLayerListItem';
import LogicLayerEditForm from '../components/LogicLayerEditForm';
import LayerDataSourceEditForm from '../components/LayerDataSourceEditForm';
import LogicLayerDetails from '../components/LogicLayerDetails';
import LayerConfigActionButtons from '../components/LayerConfigActionButtons';
import DataSourcesTable from '../components/DataSourcesTable';

import LogicalLayerWebApi from '../webapi/LogicalLayerWebApi';
import LayerDataSourceWebApi from '../webapi/LayerDataSourceWebApi';
import ClassNames from '../constants/ClassNames';

import LogicalLayerActions from '../actions/LogicalLayerActions';
import LayerDataSourceActions from '../actions/LayerDataSourceActions';

const LogicalLayerStore = getLogicalLayerStore(AppContext);
const LayerDataSourceStore = getLayerDataSourceStore(AppContext);

let LogicLayerEditFormHoc = null;
let LayerDataSourceEditFormHoc = null;

const ScrollableDataListHOC = flagHOC(ScrollableDataListRV, ['list']);
const DataSourcesTableHOC = flagHOC(DataSourcesTable, ['dataList']);

class LayerConfigWidget extends React.Component {

    constructor(props){
        super(props);

        this.DATA = {
            LOGIC_LAYERS: 'logicLayers',
            SELECTED_LOGIC_LAYER: 'selectedLogicLayer',
            EDIT_LOGIC_LAYER_ITEM: 'editLogicLayerItem',
            DELETE_LOGIC_LAYER_ITEM: 'deleteLogicLayerItem',

            LAYER_DATA_SOURCES: 'layerDataSources',
            EDIT_LAYER_DATA_SOURCES_ITEM: 'editLayerDataSourceItem',
            DELETE_LAYER_DATA_SOURCES_ITEM: 'deleteLayerDataSourceItem'
        };

        LogicLayerEditFormHoc = wrapWithCommonFormContainer(LogicLayerEditForm);
        LayerDataSourceEditFormHoc = wrapWithCommonFormContainer(LayerDataSourceEditForm);

    }

    componentDidMount(){
        LogicalLayerActions.list(this.DATA.LOGIC_LAYERS, {
            start: 0,
            end: AppContext.DEFAULT_LIST_SIZE
        });

        //AttachedLists
        const linkedListQuery = {
            $byId: ClassNames.LogicalLayer + '/' + this.DATA.SELECTED_LOGIC_LAYER + '/id',
            start: 0,
            end: AppContext.DEFAULT_LIST_SIZE
        };
        LayerDataSourceActions.list(this.DATA.LAYER_DATA_SOURCES, linkedListQuery);
    }

    static getStores(){
        return [
            LogicalLayerStore,
            LayerDataSourceStore
        ];
    }

    static calculateState(prevState, prevProps, DATA){
        return {
            ...prevState,
            i: prevState && prevState.i ? prevState.i + 1 : 1,

            [DATA.LOGIC_LAYERS]: LogicalLayerStore.getRemoteData(DATA.LOGIC_LAYERS),
            [DATA.SELECTED_LOGIC_LAYER]: LogicalLayerStore.getRemoteData(DATA.SELECTED_LOGIC_LAYER),

            [DATA.LAYER_DATA_SOURCES]: LayerDataSourceStore.getRemoteData(DATA.LAYER_DATA_SOURCES)
        };
    }

    //
    // Logic Layer
    //

    onClickNewLogicLayer(){
        FormActions.startEditFormItem(this.DATA.EDIT_LOGIC_LAYER_ITEM, {});
    }

    onClickEditLogicLayer(){
        let logicLayer = this.state[this.DATA.SELECTED_LOGIC_LAYER];
        logicLayer = logicLayer.item || logicLayer;
        FormActions.startEditFormItem(this.DATA.EDIT_LOGIC_LAYER_ITEM, {
            ...logicLayer
        });
    }

    onClickDeleteLogicLayer(){
        let logicLayer = this.state[this.DATA.SELECTED_LOGIC_LAYER];
        logicLayer = logicLayer.item || logicLayer;
        FormActions.startEditFormItem(this.DATA.DELETE_LOGIC_LAYER_ITEM, {
            ...logicLayer
        });
    }

    onLogicLayerFormSubmit(logicalLayer, validation, formId){
        if (logicalLayer.id) {
            FormActions.submitForm(LogicalLayerWebApi.updateLogicLayer, logicalLayer, formId, true);
        } else {
            FormActions.submitForm(LogicalLayerWebApi.addLogicalLayer, logicalLayer, formId, true);
        }
    }

    onLogicLayerDeleteConfirm(logicalLayer, validation, formId){
        FormActions.submitForm(LogicalLayerWebApi.deleteLogicalLayer, logicalLayer, formId, true);
    }

    selectLogicLayer(logicLayer){
        LogicalLayerActions.item(this.DATA.SELECTED_LOGIC_LAYER, { item: logicLayer });
    }

    moreLogicLayers(query){
        LogicalLayerActions.moreItems(this.DATA.LOGIC_LAYERS, query);
    }

    //
    // Layer Data Source
    //
    onClickNewLayerDataSource(){
        FormActions.startEditFormItem(this.DATA.EDIT_LAYER_DATA_SOURCES_ITEM, {
            title: '',
            typeKey: 'kml',
            config: ''
        });
    }

    onClickEditLayerDataSource(layerDataSource){
        layerDataSource = layerDataSource.item || layerDataSource;
        FormActions.startEditFormItem(this.DATA.EDIT_LAYER_DATA_SOURCES_ITEM, {
            ...layerDataSource
        });
    }

    onClickDeleteLayerDataSource(layerDataSource){
        layerDataSource = layerDataSource.item || layerDataSource;
        FormActions.startEditFormItem(this.DATA.DELETE_LAYER_DATA_SOURCES_ITEM, {
            ...layerDataSource
        });
    }

    onLayerDataSourceFormSubmit(layerDataSource, validation, formId){
        let selectedLogicalLayer = this.state[this.DATA.SELECTED_LOGIC_LAYER];
        layerDataSource.logicalLayerId = selectedLogicalLayer.item.id;
        if (layerDataSource.id) {
            FormActions.submitForm(LayerDataSourceWebApi.updateLayerDataSource, layerDataSource, formId, true);
        } else {
            FormActions.submitForm(LayerDataSourceWebApi.addLayerDataSource, layerDataSource, formId, true);
        }
    }

    onLayerDataSourceDeleteConfirm(layerDataSource, validation, formId){
        FormActions.submitForm(LayerDataSourceWebApi.deleteLayerDataSource, layerDataSource, formId, true);
    }

    moreLayerDataSource(){
        LayerDataSourceActions.moreItems(this.DATA.LAYER_DATA_SOURCES);
    }

    render(){
        const logicLayers = this.state[this.DATA.LOGIC_LAYERS];
        const selectedLogicLayer = this.state[this.DATA.SELECTED_LOGIC_LAYER];
        const layerDataSources = this.state[this.DATA.LAYER_DATA_SOURCES];

        /*eslint react/jsx-no-bind: 0*/
        return (
            <Container fluid>
                <Row>
                    <Col lg={3} md={12} sm={12} xs={12} className="nopadding">
                        <div className="padding-box">
                            <Button title="Neuen Layer anlegen" className="margin-bottom" variant="primary"
                                    onClick={this.onClickNewLogicLayer.bind(this)}>
                                Erstellen
                            </Button>

                            <ScrollableDataListHOC list={logicLayers}
                                                   activeIds={selectedLogicLayer}
                                                   className="layer-config-logic-layer-list max-height-nav"
                                                   ListItem={LogicLayerListItem}
                                                   onClick={this.selectLogicLayer.bind(this)}
                                                   onClickMore={this.moreLogicLayers.bind(this)}/>
                        </div>

                    </Col>
                    <Col lg={9} md={12} sm={12} xs={12}>
                        <Row>

                            <LogicLayerEditFormHoc formId={this.DATA.EDIT_LOGIC_LAYER_ITEM}
                                                   onFormSubmit={this.onLogicLayerFormSubmit.bind(this)}/>

                            <ConfirmFormContainer
                                formId={this.DATA.DELETE_LOGIC_LAYER_ITEM}
                                editRequired={false}
                                onFormSubmit={this.onLogicLayerDeleteConfirm.bind(this)}
                                // submitButtonText={'Löschen'}
                                Content={({ formData }) =>
                                    'Wollen Sie den Layer ' + (formData.item || formData).title + ' wirklich löschen?'
                                }
                            />

                            {(!selectedLogicLayer || !(selectedLogicLayer && selectedLogicLayer.item)) &&
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <div className="error-message">
                                        {translation.trans('please-choose-logic-layer')}
                                    </div>
                                </Col>
                            }

                            {selectedLogicLayer && selectedLogicLayer.item &&
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    {selectedLogicLayer && selectedLogicLayer._deleted && <h3>
                                        {translation.trans('item-was-deleted')}
                                    </h3>}

                                    {!(selectedLogicLayer && selectedLogicLayer._deleted) &&
                                        <div className="button-box-v">
                                            <LayerConfigActionButtons
                                                onClickEdit={this.onClickEditLogicLayer.bind(this)}
                                                onClickDelete={this.onClickDeleteLogicLayer.bind(this)}/>
                                        </div>
                                    }

                                    <div className="padding-box">
                                        <LogicLayerDetails item={selectedLogicLayer}/>
                                        <LayerDataSourceEditFormHoc formId={this.DATA.EDIT_LAYER_DATA_SOURCES_ITEM}
                                                                    onFormSubmit={this.onLayerDataSourceFormSubmit.bind(this)}/>

                                        <ConfirmFormContainer
                                            formId={this.DATA.DELETE_LAYER_DATA_SOURCES_ITEM}
                                            editRequired={false}
                                            onFormSubmit={this.onLayerDataSourceDeleteConfirm.bind(this)}
                                            Content={({ formData }) => (
                                                'Wollen Sie die Datenquelle ' + (formData.item || formData).title + ' wirklich löschen?')}
                                        />
                                    </div>

                                    <h4>{translation.trans('LayerDataSources')}</h4>

                                    {!(selectedLogicLayer && selectedLogicLayer._deleted) &&
                                        <Button title="Neue Datenquelle anf&ueml;gen" variant="primary"
                                                onClick={this.onClickNewLayerDataSource.bind(this)}>
                                            Anf&uuml;gen
                                        </Button>}

                                    <DataSourcesTableHOC dataList={layerDataSources}
                                                         onClickEdit={this.onClickEditLayerDataSource.bind(this)}
                                                         onClickDelete={this.onClickDeleteLayerDataSource.bind(this)}
                                                         onClickMore={this.moreLayerDataSource.bind(this)}/>
                                </Col>
                            }
                        </Row>
                    </Col>

                </Row>
            </Container>
        );
    }
}

LayerConfigWidget.propTypes = {};

export default ContextContainer.create(LayerConfigWidget);



// WEBPACK FOOTER //
// ./js/widgets/LayerConfigWidget.jsx